import { moment } from '@eb/date';
import { formatDate } from '@eb/datetime';
import { gettext } from '@eb/i18n';
import { lazyGettext } from '@eb/lazy-gettext';

export const CREATE_SCHEDULE_PUBLISH_FORM_NAME = 'createSchedulePublish';
export const PUBLISH_PREVIEW_SCHEDULE_PUBLISH_FORM_NAME =
    'publishPreviewSchedulePublish';

export const EVENT_DATE_PICKER_PREFIX = 'scheduleEventPublish-';
export const MIN_PUBLISH_DATE = formatDate(moment());

export const SCHEDULE_PUBLISH_SCHEDULED = 'scheduled';
export const SCHEDULE_PUBLISH_STATUS = 'schedule_publish_status';
export const SCHEDULE_PUBLISH_DATE = 'schedule_publish_date';

export const PUBLISH_LABEL = gettext('Publish');
export const SCHEDULE_PUBLISH_LABEL = gettext('Schedule');
export const PUBLIC_PUBLISH = gettext('Publish Now');
export const PUBLIC_SCHEDULE = gettext('Schedule for later');

export const PRIVATE_PUBLISH = gettext('No, keep it private');
export const PRIVATE_SCHEDULE = gettext('Yes, schedule to share publicly');

export const PUBLIC_SCHEDULE_PUBLISH_DATA_HEADLINE = gettext(
    'When should we publish your event?',
);
export const PRIVATE_SCHEDULE_PUBLISH_DATA_HEADLINE = gettext(
    'Will this event ever be public?',
);
export const EVENT_SALES_STATUS_EXPANSION = 'event_sales_status';
export const EVENT_STATUS_DRAFT = 'draft';
export const EVENT_STATUS_LIVE = 'live';

export const PUBLIC_VALUE = 'public';
export const PRIVATE_VALUE = 'private';

export const PUBLISH_CHECKBOX_VALUE = 'publish';
export const SCHEDULE_CHECKBOX_VALUE = 'schedule-publish';

export const SCHEDULE_PUBLIC_CHECKBOX_VALUE = 'schedule-public';

export const PUBLISH_COPY = gettext('Publish Now');
export const SCHEDULE_COPY = gettext('Schedule Publish');
export const SCHEDULE_PUBLISH_DATA_HEADLINE = gettext('Publish Options');

export const RADIO_OPTIONS = [
    { display: PUBLISH_COPY, value: PUBLISH_CHECKBOX_VALUE },
    { display: SCHEDULE_COPY, value: SCHEDULE_CHECKBOX_VALUE },
];

export const SCHEDULE_RADIO_OPTIONS = {
    [PUBLIC_VALUE]: [
        {
            display: PUBLIC_PUBLISH,
            value: PUBLISH_CHECKBOX_VALUE,
        },
        {
            display: PUBLIC_SCHEDULE,
            value: SCHEDULE_CHECKBOX_VALUE,
        },
    ],
    [PRIVATE_VALUE]: [
        {
            display: PRIVATE_PUBLISH,
            value: PUBLISH_CHECKBOX_VALUE,
        },
        {
            display: PRIVATE_SCHEDULE,
            value: SCHEDULE_PUBLIC_CHECKBOX_VALUE,
        },
    ],
};

export const BASIC_INVENTORY_INFO_EXPANSION = 'basic_inventory_info';
export const EVENT_API_EXPANSIONS = [BASIC_INVENTORY_INFO_EXPANSION];

export const STATE_RESOURCE_CACHE_NAME = 'resourceCache';

export const SHOW_SCHEDULE_PUBLISH_NOTIFICATION_DELAY = 20000;

export const SCHEDULE_PUBLISH_DATA = {
    headline: lazyGettext('Schedule Publish'),
    description: lazyGettext("Time zone is the same as your event's"),
    datePickerLabel: lazyGettext('Date of publish'),
    datePickerPlaceholder: lazyGettext('Select Publish Date'),
    timePickerLabel: lazyGettext('Time of publish'),
    timePickerPlaceholder: lazyGettext('Select Publish Time'),
    publicEventLinkToPrivacySettings: lazyGettext(
        'Your event will be <span class="eds-text-weight--heavy">Public</span>. Modify this in <a class="eds-link" href="%(privacySettingsLink)s">Privacy Settings</a>.',
    ),
    privateEventLinkToPrivacySettings: lazyGettext(
        'Your event will be <span class="eds-text-weight--heavy">Private</span>. Modify this in <a class="eds-link" href="%(privacySettingsLink)s">Privacy Settings</a>.',
    ),
    privateEventLinkToPrivacySettingsWithScheduledPublic: lazyGettext(
        'Your event will be <span class="eds-text-weight--heavy">Private</span>. Change this or schedule a date and time to make it Public in <a class="eds-link" href="%(privacySettingsLink)s">Privacy Settings</a>.',
    ),
    confirmSchedule: lazyGettext('Schedule'),
    cancelSchedule: lazyGettext('Cancel'),
};
